module.exports = __webpack_public_path__ + "static/img/spac_head.ba4aa95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spac_head.png
// module id = ELZ1
// module chunks = 15